(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["watchit-star-wars"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=()=>{const root=document.querySelector('[data-wi-star-wars]');if(!root||root.dataset.ready)return;root.dataset.ready='true';let side='all';const status=root.querySelector('[data-wi-sw-status]');const labels={dark:root.querySelector('[data-wi-side="dark"] .wi-sw-tile-label').textContent,light:root.querySelector('[data-wi-side="light"] .wi-sw-tile-label').textContent,droids:root.querySelector('[data-wi-side="droids"] .wi-sw-tile-label').textContent};const match=(handle)=>side==='all'||(side==='dark'?/darth|death-star|imperial|stormtrooper/.test(handle):side==='light'?/jedi|yoda|luke|ahsoka|rebel|chewbacca|millennium|bespin|duel|trench-run/.test(handle):/r2-d2|c-3po/.test(handle));const apply=()=>{const grid=document.querySelector('#bls__product-grid');if(!grid)return;let count=0;grid.querySelectorAll('[data-item-type="product"]').forEach(item=>{const link=item.querySelector('a[href*="/products/"]');const handle=link?.getAttribute('href')?.split('/products/')[1]?.split(/[?#]/)[0]||'';const show=match(handle);item.classList.toggle('wi-sw-hidden',!show);if(show)count++;});root.querySelectorAll('[data-wi-side]').forEach(link=>link.setAttribute('aria-pressed',String(link.dataset.wiSide===side)));const reset=root.querySelector('.wi-sw-reset');reset.hidden=side==='all';const message=side==='all'?status.dataset.all:status.dataset.matches.replace('[count]',String(count)).replace('[side]',labels[side]);if(status.textContent!==message)status.textContent=message;};root.querySelectorAll('[data-wi-side]').forEach(link=>{link.setAttribute('role','button');link.addEventListener('click',()=>{side=link.dataset.wiSide;apply();});link.addEventListener('keydown',event=>{if(event.key===' '){event.preventDefault();link.click();}});});const observer=new MutationObserver(mutations=>{if(mutations.some(m=>m.type==='childList'))apply();});const main=document.querySelector('#MainContent');if(main)observer.observe(main,{childList:true,subtree:true});apply();};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();document.addEventListener('shopify:section:load',init);})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wi-editorial-collection"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (root) => {
    root.querySelectorAll('[data-wi-collection-group]').forEach((group) => {
      if (group.dataset.wiReady) return;
      group.dataset.wiReady = 'true';
      const tabs = Array.from(group.querySelectorAll('[role="tab"]'));
      const select = (tab) => {
        tabs.forEach((item) => {const active = item === tab; item.setAttribute('aria-selected', String(active)); item.tabIndex = active ? 0 : -1; document.getElementById(item.getAttribute('aria-controls')).hidden = !active;});
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', (event) => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) {event.preventDefault(); select(tabs[next]); tabs[next].focus();}
        });
      });
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', () => initialize(document));
})();

  } catch(e) { console.error(e); }
})();
})();
